import { FormattedMessage } from 'react-intl';
import React from 'react';
import { Alert } from '@printdeal/ui-library';
import { SelectorContent, useMatchesState, usePricesMachineContext } from '@printdeal/product-selector';
import InventoryCheckQuoteButton from './InventoryCheck/InventoryCheckQuoteButton';
import { formatAttributes, getPriceGroups } from '../../../../helpers/PricesHelper';
import type { GroupSelection, ISelection } from '../../../../types/selector/Selector';
import { dispatchDataLayerEntry } from '../../../../helpers/dataLayerHelpers/productDataLayerHelper';

interface Props {
  product: SelectorContent['product'];
  contentfulId: string;
  currentSelection: ISelection;
  groupSelection: GroupSelection[];
  totalQuantity: number;
}

const ProductUnavailableAlert = ({
  product, contentfulId, currentSelection, groupSelection, totalQuantity,
}: Props) => {
  const isInsufficientInventory = useMatchesState({ STARTED: { 'FETCHING DATA': { 'ARRIVAL DATES': 'INSUFFICIENT INVENTORY' } } });
  const showingRequestQuote = usePricesMachineContext((pricesMachineState) => pricesMachineState.matches('Showing request quote'));

  if (showingRequestQuote || isInsufficientInventory) {
    dispatchDataLayerEntry('selector', 'warning', {
      message: 'product unavailable',
      contentful_id: contentfulId,
    }, 'selector_message');
  }

  if (!isInsufficientInventory && !showingRequestQuote) {
    return null;
  }

  return (
    <Alert variant="warning" className="pd-mb-5 pd-mt-3" data-cy="productUnavailableAlert">
      <FormattedMessage
        id="product.unavailable.alert"
        defaultMessage="
          Some of the products you are trying to order are currently out of stock. We would like to get
          in touch with you, to check how we can still assist you. If you would like our assistance,
          please contact us using our quote form:"
      />
      <div className="pd-text-right">
        <InventoryCheckQuoteButton
          product={product}
          contentfulId={contentfulId}
          attributes={formatAttributes(Object.entries(currentSelection || {}))}
          group={getPriceGroups(groupSelection)}
          quantity={totalQuantity || 0}
        />
      </div>
    </Alert>
  );
};

export default ProductUnavailableAlert;
